<script setup lang="ts">
import { computed } from 'vue';
import { UiText } from '@shopexperts/shared';

const props = defineProps<{
    quality: number;
    communication: number;
    timelines: number;
    valueForMoney: number;
}>();

const totalScore = computed(() => {
    const scores = [props.quality, props.communication, props.timelines, props.valueForMoney];
    const validScores = scores.filter(score => score > 0);
    
    if (validScores.length === 0) {
        return '0.00';
    }
    
    const average = validScores.reduce((sum, score) => sum + score, 0) / validScores.length;
    return average.toFixed(2);
});
</script>

<template>
    <div class="flex flex-col gap-4 w-full">
        <div class="bg-se-gray-300 h-px w-full"></div>
        <div class="flex items-center justify-between w-full text-se-gray-900">
            <UiText as="p" variant="p" class="text-se-gray-900">
                Total Score:
            </UiText>
            <UiText as="p" variant="h2" class="text-se-gray-900 font-semibold">
                {{ totalScore }}
            </UiText>
        </div>
    </div>
</template>

